var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.data},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }